/* eslint-disable */
export default {
  createLog: 'Crea registro',
  creating: 'Creazione in corso',
  save: 'Salva',
  saving: 'Salvataggio in corso',
  saved: 'Salvato',
  view: 'Visualizza',
  creatingFailed: 'Creazione non riuscita.',
  savingFailed: 'Salvataggio non riuscito.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
